import React, { Component } from "react";
import axios from "axios";
import { Button, Spin, Typography, Input, Space, message } from "antd";
import { black } from "material-ui/styles/colors";
import { finalTabValidator } from "../utils/finalTabValidator";

class finalTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editMode: false,
      finalTab: null,
      editableView: {
        id: "",
        title: "",
        subtitle: "",
        config_title: "",
        ref_buttons: {},
      },
      formErrors: {},
    };

    this.getFinalTab = this.getFinalTab.bind(this);
  }
  componentDidMount() {
    this.getFinalTab();
  }
  async getFinalTab() {
    const res = await axios.post("https://dev.nadu.xyz/dev/admin/getFinalTab");
    if (typeof res.data !== "undefined") {
      this.setState({
        finalTab: res.data,
      });
    }
  }
  handleEditMode() {
    const content = this.state.finalTab;
    this.setState({
      editMode: true,
      editableView: {
        id: content.id,
        title: content.title,
        subtitle: content.subtitle,
        config_title: content.config_title,
        ref_buttons: content.buttons.reduce((acc, button) => {
          acc[button.id] = { title: button.text, icon: button.icon };
          return acc;
        }, {}),
      },
    });
  }
  handleCancelEdit() {
    this.setState({
      editMode: false,
      editableView: {
        id: "",
        title: "",
        subtitle: "",
        config_title: "",
        ref_buttons: {},
      },
    });
  }
  validateAndSetErrors() {
    const { editableView } = this.state;
    const errors = finalTabValidator(editableView);
    this.setState({ formErrors: errors });
  }
  handleInputChange(event, btnId) {
    const { name, value } = event.target;
    if (btnId) {
      this.setState(
        {
          editableView: {
            ...this.state.editableView,
            ref_buttons: {
              ...this.state.editableView.ref_buttons,
              [btnId]: {
                ...this.state.editableView.ref_buttons[btnId],
                [name]: value,
              },
            },
          },
        },
        () => this.validateAndSetErrors()
      );
    } else {
      this.setState(
        { editableView: { ...this.state.editableView, [name]: value } },
        () => this.validateAndSetErrors()
      );
    }
  }
  handleEditForm() {
    axios
      .post("https://dev.nadu.xyz/dev/admin/updateFinalTab", {
        params: {
          node_id: this.state.finalTab.id,
          ...this.state.editableView,
        },
      })
      .then((res) => {
        if (res.data.ok) {
          message.success("Vista final editada correctamente.");
          this.getFinalTab();
          this.setState({
            editMode: false,
            editableView: {
              id: "",
              title: "",
              subtitle: "",
              config_title: "",
              ref_buttons: {},
            },
          });
        } else {
          message.error(res.data.error);
        }
      })
      .catch(() => message.error("Hubo un error al editar la vista final."));
  }
  render() {
    return this.state.finalTab === null ? (
      <Spin />
    ) : (
      <div
        style={{
          position: "relative",
          marginTop: "20px",
          marginBottom: "30px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{ position: "absolute", right: 0, display: "flex", gap: 4 }}
        >
          {this.state.editMode ? (
            <Space>
              <Button onClick={() => this.handleCancelEdit()}>
                Cancelar Cambios
              </Button>
              <Button type="primary" onClick={() => this.handleEditForm()}>
                Guardar Cambios
              </Button>
            </Space>
          ) : (
            <Button onClick={() => this.handleEditMode()}>Editar Vista</Button>
          )}
        </div>
        <div
          style={{
            width: "50%",
            padding: "50px 30px",
            color: "white",
            borderRadius: "8px",
            backgroundColor: "#131313",
            marginTop: "40px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 5,
          }}
        >
          <svg
            width="60px"
            heighth="60px"
            version="1.1"
            viewBox="0 0 130.2 130.2"
          >
            <circle
              className="path circle"
              fill="none"
              stroke="#73AF55"
              strokeWidth="6"
              strokeMiterlimit="10"
              cx="65.1"
              cy="65.1"
              r="62.1"
            />
            <polyline
              className="path check"
              fill="none"
              stroke="#73AF55"
              strokeWidth="6"
              strokeLinecap="round"
              strokeMiterlimit="10"
              points="100.2,40.2 51.5,88.8 29.8,67.5 "
            />
          </svg>
          <div style={{ marginTop: 20 }}>
            {this.state.editMode ? (
              <Input
                style={{
                  color: "white",
                  backgroundColor: "#131313",
                  textAlign: "center",
                  width: "fit-content",
                }}
                placeholder="Introducir título"
                name="title"
                value={this.state.editableView.title}
                onChange={(event) => this.handleInputChange(event)}
                status={this.state.formErrors.title ? "error" : ""}
              />
            ) : (
              <Typography.Title style={{ color: "white", margin: 0 }} level={4}>
                {this.state.finalTab.title}
              </Typography.Title>
            )}
          </div>

          {this.state.editMode ? (
            <Input
              style={{
                color: "white",
                backgroundColor: "#131313",
                textAlign: "center",
                width: "90%",
              }}
              placeholder="Introducir descripción"
              name="subtitle"
              value={this.state.editableView.subtitle}
              onChange={(event) => this.handleInputChange(event)}
              status={this.state.formErrors.subtitle ? "error" : ""}
            />
          ) : (
            <Typography style={{ color: "white" }}>
              {this.state.finalTab.subtitle}
            </Typography>
          )}
          <div style={{ marginTop: 20 }}>
            {this.state.editMode ? (
              <Input
                style={{
                  color: "white",
                  backgroundColor: "#131313",
                  textAlign: "center",
                  width: "fit-content",
                }}
                placeholder="Introducir título del pack"
                name="config_title"
                value={this.state.editableView.config_title}
                onChange={(event) => this.handleInputChange(event)}
                status={this.state.formErrors.config_title ? "error" : ""}
                hasFeedback
              />
            ) : (
              <Typography.Title style={{ color: "white", margin: 0 }} level={4}>
                {this.state.finalTab.config_title}
              </Typography.Title>
            )}
          </div>
          <div
            style={{
              backgroundColor: "#00BA89",
              width: "130px",
              height: "55px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <h5 style={{ color: "white", fontWeight: "bold", margin: 0 }}>
              AAA1234
            </h5>
          </div>

          <div
            style={{
              width: "100%",
              marginTop: "24px",
              display: "flex",
              flexDirection: "column-reverse",
              alignItems: "center",
              justifyContent: "center",
              gap: "20px",
            }}
          >
            {this.state.finalTab.buttons.map((button, idx) => {
              const isPrimary = button.text === "Ir a la web";
              const primaryStyles = {
                border: "1px solid #00BA89",
              };
              const secondaryStyles = {
                backgroundColor: "white",
                border: "1px solid white",
                color: black,
              };
              const componentStyles = {
                ...(isPrimary ? primaryStyles : secondaryStyles),
                padding: "10px",
                borderRadius: "6px",
                width: "90%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "14px",
              };
              return (
                <div key={idx} style={componentStyles}>
                  <div
                    style={{
                      width: "20px",
                      height: "auto",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: decodeURIComponent(button.icon)
                        .replace(/\\\"/g, '"')
                        .replace("<svg ", '<svg width="100%" height="100%" '),
                    }}
                  />
                  {this.state.editMode ? (
                    <Input
                      style={{
                        color: isPrimary ? "white" : "black",
                        backgroundColor: isPrimary ? "#131313" : "white",
                        width: "fit-content",
                      }}
                      placeholder="Introducir título del botón."
                      value={
                        this.state.editableView.ref_buttons[button.id].title
                      }
                      name="title"
                      onChange={(event) =>
                        this.handleInputChange(event, button.id)
                      }
                    />
                  ) : (
                    <Typography
                      style={{ color: isPrimary ? "white" : "black" }}
                    >
                      {button.text}
                    </Typography>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default finalTab;



// WEBPACK FOOTER //
// ./src/views/Configurator/Tabs/FinalTab.jsx